import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';
import {XauditModel} from '../xaudit.model';

export class FormMasterItemConfigurationModel extends XauditModel {
    DFormMasterItemId: string;
    TDOCID: number;
    DFormItemName: string;
    enumFormControlID: string;
    Label: string;
    enumFormControl: EnumValidValueItemModel;
}
